import { backbone } from '@visikon/backbone';
import { Button } from '@visikon/spine';
import { Tokens } from '@visikon/spine/src/styles/tokens';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { EditButton } from '../../components/edit/EditButton';
import { I18N } from '../../internationalization/AppText';
import { IState } from '../../reducers/reducer';
import { useSelfServiceUnsavedChanges } from '../embeddedMessageScript/EmbeddedMessageScript';
import { ContactDialog } from './ContactDialog';

export const ContactButton = () => {
  const contactText = useSelector((state: IState) => state.resources.content?.contactText);
  const dialogRef = React.useRef<HTMLDialogElement>(null);
  const languageCode = backbone.store.getState().country.languageCode;

  const unsavedChanges = useSelfServiceUnsavedChanges();
  const unsavedContact = unsavedChanges.operations?.find((op) => op.contentType === 'contactText')?.data;

  const unsavedContent = unsavedContact?.translations?.find((t) => (t.language = languageCode));

  const content = unsavedContent || contactText;
  const markdown = content?.content?.document?.data?.markdown;

  return contactText ? (
    <>
      <div style={{ width: '500', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Button
          onClick={() => dialogRef.current?.showModal()}
          size={'small'}
          variant={'ghost'}
          style={{
            textTransform: 'none',
            background: 'rgba(0, 109, 179, 0.06)',
            fontWeight: Tokens.text.weight.bold,
            padding: '8px 12px',
          }}
        >
          <I18N text={'contact'} />
        </Button>
        <EditButton id="contact" contentType="contact" />
      </div>
      <ContactDialog dialogRef={dialogRef} document={content} markdown={markdown} />
    </>
  ) : null;
};
